import { Bar, mixins } from "vue-chartjs"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        yMax: {
            type: Number,
            default: 0
        }
    },
    watch: {
        yMax: {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    methods: {
        click (event) {
            try {
                const chart_element = this._chart.getElementAtEvent(event)[0]
                const project = this._chart.config.data.datasets[chart_element._datasetIndex].project
                this.$emit("click", project.id, event)
            } catch (e) {}
        }
    },
    computed: {
        options () {
            return {
                onClick: this.click,
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return data.datasets[tooltipItem.datasetIndex].label
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            max: this.yMax,
                            fontColor: "#00274F",
                            maxTicksLimit: this.yMax || 1
                        },
                        gridLines: {
                            display: this.yMax > 0,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: false,
                    position: "right",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
